// RSVP payloads shared between server and SPA.
//
// The load-bearing idea in this file: `status` and the day-of confirmation are
// TWO INDEPENDENT FIELDS, and nothing may derive one from the other.
//
//   status          — what the member said in advance.
//   confirmedDayof  — what the member said ON THE DAY, when asked "still in?".
//
// They tell two different stories, and the gap between them is the whole product
// differentiator: ghost RSVPs (yes, then no-show) are the problem day-of
// confirmation solves. The confirm flow never writes `status`, and the RSVP flow
// never writes `confirmedDayof`. See docs/domain.md.
export const RSVP_STATUSES = ['yes', 'no', 'maybe'];
/**
 * Roster display order: yes, then maybe, then no; day-of confirmed first within
 * each group. Exported so the SPA can re-sort an optimistically updated list the
 * same way the server did, rather than inventing a second ordering.
 */
export const RSVP_STATUS_ORDER = {
    yes: 0,
    maybe: 1,
    no: 2,
};
export function rsvpStatusLabel(status) {
    if (status === 'yes')
        return 'Going';
    if (status === 'maybe')
        return 'Maybe';
    return 'Not going';
}
//# sourceMappingURL=rsvp.js.map